import { create } from "zustand";
import type { IViewConfig } from "lola-framework-ui-test";
import type { IErrorState } from "../shared/error/interfaces/error";
import { errorInitialState, themeFormattedInitialState } from "../constants";

interface GlobalState {
  theme: IViewConfig;
  setTheme: (theme: IViewConfig) => void;

  linkId: string | null;
  setLinkId: (linkId: string | null) => void;

  errorState: IErrorState;
  setErrorState: (errorState: IErrorState) => void;
}

export const useStore = create<GlobalState>((set) => ({
  theme: themeFormattedInitialState,
  setTheme: (theme) => {
    set(() => ({ theme }));
  },

  linkId: null,
  setLinkId: (linkId) => {
    set(() => ({ linkId }));
  },

  errorState: errorInitialState,
  setErrorState: (errorState) => {
    set(() => ({ errorState }));
  },
}));
